import { Logo } from "./logo";

const Loader = () => {
  return (
    <div className="from-background via-background to-primary/5 dark:to-primary/5 flex min-h-screen items-center justify-center bg-gradient-to-br p-4">
      <div className="mx-auto w-full max-w-md space-y-8 text-center">
        {/* Main loading animation */}
        <div className="relative">
          {/* Spinning outer ring */}
          <div className="relative mx-auto h-32 w-32">
            <div className="border-primary/30 dark:border-primary/30 absolute inset-0 rounded-full border-4"></div>
            <div className="border-t-primary dark:border-t-primary absolute inset-0 animate-spin rounded-full border-4 border-transparent"></div>

            {/* Inner pulsing circle */}
            <div className="bg-primary/10 dark:bg-primary/10 border-primary/20 dark:border-primary/20 animate-pulse-gentle absolute inset-4 rounded-full border backdrop-blur-sm">
              <div className="flex h-full w-full items-center justify-center">
                <Logo showText={false} />
              </div>
            </div>
          </div>
        </div>

        {/* Loading text with animated dots */}
        <div className="animate-fade-in-delayed space-y-4">
          <h2 className="text-foreground text-2xl font-semibold">Loading</h2>
          <div className="flex items-center justify-center space-x-1">
            <div className="bg-primary dark:bg-primary animate-bounce-dot h-2 w-2 rounded-full"></div>
            <div
              className="bg-primary dark:bg-primary animate-bounce-dot h-2 w-2 rounded-full"
              style={{ animationDelay: "0.1s" }}
            ></div>
            <div
              className="bg-primary dark:bg-primary animate-bounce-dot h-2 w-2 rounded-full"
              style={{ animationDelay: "0.2s" }}
            ></div>
          </div>
        </div>

        {/* Progress bar */}
        <div className="animate-fade-in-slow mx-auto w-full max-w-xs">
          <div className="bg-primary/20 dark:bg-primary/20 h-2 overflow-hidden rounded-full">
            <div className="from-primary/80 to-primary dark:from-primary dark:to-primary animate-loading-bar h-full rounded-full bg-gradient-to-r"></div>
          </div>
        </div>

        {/* Loading message */}
        <p className="text-muted-foreground animate-fade-in-final text-sm">
          Please wait while we prepare your content...
        </p>
      </div>

      {/* Floating background elements */}
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="bg-primary/20 animate-float-slow absolute top-1/4 left-1/4 h-2 w-2 rounded-full"></div>
        <div className="bg-primary/15 animate-float-slower absolute top-3/4 right-1/4 h-3 w-3 rounded-full"></div>
        <div className="bg-primary/25 animate-float-fast absolute top-1/2 left-3/4 h-1 w-1 rounded-full"></div>
        <div className="bg-primary/30 animate-float-medium absolute top-1/3 right-1/3 h-1.5 w-1.5 rounded-full"></div>
      </div>
    </div>
  );
};

export default Loader;
